import router, { asyncRoutes, resetRouter } from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, removeToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { getRoutes } from '@/api/login'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/backweapp', '/404', '/agreementInfos'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
	// start progress bar
	NProgress.start()
	// set page title
	// 判断 title 是否为动态设置的
	if (typeof to.meta.title === 'function') {
		document.title = getPageTitle(to.meta.title(to.params))
	} else {
		document.title = getPageTitle(to.meta.title)
	}

	// determine whether the user has logged in
	const hasToken = getToken() || false
	if (hasToken) {
		if (to.path === '/login') {
			NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
		} else {
			// determine whether the user has obtained his permission roles through getInfo
			const hasRoles = store.getters.roles && store.getters.roles.length > 0

			if (hasRoles) {
				if (store.getters.permission_routes.length === 0) {
					const accessRoutes = await store.dispatch(
						'permission/generateRoutes',
						hasRoles
					)
					router.addRoutes(accessRoutes)
				}
				next()
			} else {
				try {
					// get user info
					// note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
					const roles = await store.dispatch('user/setRoles')
					const accessRoutes = await store.dispatch(
						'permission/generateRoutes',
						roles
					)
					router.addRoutes(accessRoutes)

					next({ ...to, replace: true })
				} catch (error) {
					// remove token and go to login page to re-login
					await store.dispatch('user/resetToken')
					Message.error(error || 'Has Error')
					next(`/login?redirect=${to.path}`)
					NProgress.done()
				}
			}
		}
	} else {
		/* has no token*/
		if (whiteList.indexOf(to.path) !== -1) {
			// in the free login whitelist, go directly
			next()
		} else {
			// other pages that do not have permission to access are redirected to the login page.
			next(`/login`)
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	// finish progress bar
	NProgress.done()
})
